<div class="flex flex-col gap-6 items-center justify-center">
  <img *ngIf="emojiPathUrl" class="w-9" [src]="emojiPathUrl" alt="emoji" />
  <img *ngIf="illustrationPathUrl" class="w-24" [src]="illustrationPathUrl" alt="illustration" />
  <h4 *ngIf="title" class="text-xl max-w-[350px] text-center" [innerHtml]="title"></h4>
  <p *ngIf="msg" class="text-base max-w-[350px] text-center" [innerHtml]="msg"></p>
  <ng-content select="[suffix]"></ng-content>
</div>
